module.exports = __webpack_public_path__ + "img/Logo TR Search Engine.d2dda6a8.png";